const base = {
  dev: 'http://act.feng.com/',
  prod: 'http://act.feng.com/',
};

export default base;



// WEBPACK FOOTER //
// ./src/api/api.base.js